import { formatDateShort } from '@/lib/date-format';
import { uiFb } from '@/lib/i18n';
import type { CalendarEvent } from '@/lib/types';

interface PeakFestivalsListProps {
  festivals: CalendarEvent[];
  lang: string;
}

export function PeakFestivalsList({ festivals, lang }: PeakFestivalsListProps) {
  if (festivals.length === 0) return null;

  return (
    <div className="mb-8 border-t border-border-subtle pt-6">
      <h2 className="font-heading text-xl font-bold text-text-primary md:text-2xl">
        {uiFb('ui.festivals_peak_season', 'Festivals During Peak Season', lang)}
      </h2>
      <div className="mt-4 space-y-2">
        {festivals.map(event => (
          <div
            key={event.id}
            className="flex items-start gap-3 content-card p-3"
          >
            <span className="mt-0.5 inline-block rounded bg-surface-root px-2 py-0.5 text-xs font-medium text-text-secondary">
              {formatDateShort(event.dateStart, lang)}
            </span>
            <div>
              <span className="text-sm font-medium text-text-primary">{event.title}</span>
              {event.isGazetted && (
                <span className="ml-2 rounded badge-success px-1.5 py-0.5 text-caption font-medium">
                  {uiFb('ui.holiday', 'Holiday', lang)}
                </span>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
